module.exports = __webpack_public_path__ + "cc12c662600895b760a0543fbf2b4e5a.svg";